import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../../styles/SilverAnniversary.css';

const SilverAnniversary = ({ isPreview = true }) => {
  const { coupleNames } = useParams();
  const [isRevealed, setIsRevealed] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [rsvpData, setRsvpData] = useState({
    name: '',
    email: '',
    attending: '',
    guests: '1',
    message: ''
  });

  // Parse couple names
  const formatNames = (names) => {
    if (!names) return { name1: 'Roberto', name2: 'Maria' };
    const parts = names.split('-and-');
    if (parts.length === 2) {
      return {
        name1: parts[0].split('-').map(word => 
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ).join(' '),
        name2: parts[1].split('-').map(word => 
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ).join(' ')
      };
    }
    return { name1: 'Roberto', name2: 'Maria' };
  };

  const names = formatNames(coupleNames);

  const invitationData = {
    husband: names.name1,
    wife: names.name2,
    yearsMarried: '25',
    weddingDate: 'March 15, 2001',
    celebrationDate: 'March 15, 2026',
    celebrationDay: 'Sunday',
    celebrationTime: '5:00 PM',
    venue: 'Manila Hotel',
    venueAddress: 'One Rizal Park, Manila',
    message: 'Twenty-five years of love, laughter, and countless precious memories. Join us as we celebrate this silver milestone.',
    milestones: [
      { year: '2001', event: 'Said "I Do"', icon: '💒' },
      { year: '2003', event: 'First Child Born', icon: '👶' },
      { year: '2011', event: '10th Anniversary', icon: '🎉' },
      { year: '2026', event: 'Silver Jubilee', icon: '🥈' }
    ],
    hostedBy: 'The Santos Family'
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsRevealed(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="silver-anniversary">
      {/* Decorative Elements */}
      <div className="silver-elements">
        <div className="silver-shimmer"></div>
        <div className="silver-ring ring-left">◇</div>
        <div className="silver-ring ring-right">◇</div>
        <div className="sparkle s1">✦</div>
        <div className="sparkle s2">✦</div>
        <div className="sparkle s3">✦</div>
        <div className="sparkle s4">✦</div>
      </div>

      {/* Main Content */}
      <div className={`silver-container ${isRevealed ? 'revealed' : ''}`}>
        {/* Navigation */}
        <nav className="silver-nav">
          <button 
            className={activeSection === 'home' ? 'active' : ''} 
            onClick={() => setActiveSection('home')}
          >
            Invitation
          </button>
          <button 
            className={activeSection === 'journey' ? 'active' : ''} 
            onClick={() => setActiveSection('journey')}
          >
            Our Journey
          </button>
          <button 
            className={activeSection === 'rsvp' ? 'active' : ''} 
            onClick={() => setActiveSection('rsvp')}
          >
            RSVP
          </button>
        </nav>

        {/* Home Section */}
        {activeSection === 'home' && (
          <section className="silver-section home-section">
            <div className="anniversary-badge">
              <span className="badge-number">25</span>
              <span className="badge-text">Years</span>
            </div>

            <p className="invitation-text">Together with our family, we invite you to celebrate</p>

            <div className="couple-names">
              <span className="name">{invitationData.husband}</span>
              <span className="ampersand">&</span>
              <span className="name">{invitationData.wife}</span>
            </div>

            <div className="anniversary-title">
              <span className="title-line">Silver Wedding</span>
              <span className="title-accent">Anniversary</span>
            </div>

            <div className="silver-divider">
              <span className="divider-line"></span>
              <span className="divider-icon">◆</span>
              <span className="divider-line"></span>
            </div>

            <p className="invitation-message">{invitationData.message}</p>

            <div className="event-details">
              <div className="detail-card">
                <span className="detail-icon">📅</span>
                <span className="detail-label">Date</span>
                <span className="detail-value">{invitationData.celebrationDate}</span>
              </div>
              <div className="detail-card">
                <span className="detail-icon">⏰</span>
                <span className="detail-label">Time</span>
                <span className="detail-value">{invitationData.celebrationTime}</span>
              </div>
              <div className="detail-card">
                <span className="detail-icon">📍</span>
                <span className="detail-label">Venue</span>
                <span className="detail-value">{invitationData.venue}</span>
              </div>
            </div>

            <p className="venue-address">{invitationData.venueAddress}</p>

            <button 
              className="silver-btn"
              onClick={() => setActiveSection('rsvp')}
            >
              Kindly Respond
            </button>
          </section>
        )}

        {/* Journey Section */}
        {activeSection === 'journey' && (
          <section className="silver-section journey-section">
            <h2 className="section-title">
              <span className="title-decor">✦</span>
              Our Love Story
              <span className="title-decor">✦</span>
            </h2>

            <div className="wedding-date-box">
              <span className="wedding-label">Married on</span>
              <span className="wedding-date">{invitationData.weddingDate}</span>
            </div>

            <div className="milestones-timeline">
              {invitationData.milestones.map((milestone, index) => (
                <div key={index} className="milestone-item">
                  <div className="milestone-year">{milestone.year}</div>
                  <div className="milestone-connector">
                    <span className="connector-dot"></span>
                    {index < invitationData.milestones.length - 1 && (
                      <span className="connector-line"></span>
                    )}
                  </div>
                  <div className="milestone-content">
                    <span className="milestone-icon">{milestone.icon}</span>
                    <span className="milestone-event">{milestone.event}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="quote-box">
              <span className="quote-mark">"</span>
              <p className="quote-text">
                Twenty-five years of marriage means twenty-five years of choosing each other, every single day.
              </p>
              <span className="quote-mark closing">"</span>
            </div>

            <div className="hosted-by">
              <span className="hosted-label">Celebration hosted by</span>
              <span className="hosted-name">{invitationData.hostedBy}</span>
            </div>

            <button 
              className="silver-btn"
              onClick={() => setActiveSection('rsvp')}
            >
              RSVP Now
            </button>
          </section>
        )}

        {/* RSVP Section */}
        {activeSection === 'rsvp' && (
          <section className="silver-section rsvp-section">
            <h2 className="section-title">
              <span className="title-decor">✦</span>
              RSVP
              <span className="title-decor">✦</span>
            </h2>

            <form className="silver-rsvp-form" onSubmit={(e) => e.preventDefault()}>
              <p className="rsvp-intro">We would be honored by your presence</p>
              <p className="rsvp-deadline">Please respond by March 1, 2026</p>

              <div className="form-group">
                <label>Your Name</label>
                <input
                  type="text"
                  name="name"
                  value={rsvpData.name}
                  placeholder="Enter your full name"
                  disabled={isPreview}
                />
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={rsvpData.email}
                  placeholder="your.email@example.com"
                  disabled={isPreview}
                />
              </div>

              <div className="form-group">
                <label>Will you be attending?</label>
                <div className="attendance-options">
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="yes"
                      disabled={isPreview}
                    />
                    <span className="option-check">◆</span>
                    <span className="option-text">Joyfully Accepts</span>
                  </label>
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="no"
                      disabled={isPreview}
                    />
                    <span className="option-check">◇</span>
                    <span className="option-text">Regretfully Declines</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Number of Guests</label>
                <select
                  name="guests"
                  value={rsvpData.guests}
                  disabled={isPreview}
                >
                  <option value="1">1 Guest</option>
                  <option value="2">2 Guests</option>
                  <option value="3">3 Guests</option>
                  <option value="4">4 Guests</option>
                </select>
              </div>

              <div className="form-group">
                <label>Message for the Couple (Optional)</label>
                <textarea
                  name="message"
                  value={rsvpData.message}
                  placeholder="Share your wishes for Roberto & Maria..."
                  rows="3"
                  disabled={isPreview}
                />
              </div>

              <button type="submit" className="silver-btn full-width" disabled={isPreview}>
                Send RSVP
              </button>
            </form>
          </section>
        )}

        {/* Watermark */}
        <div className="silver-watermark">
          <a href="/invitations" className="back-to-templates-btn">Back to Designs</a>
          <p>Crafted with love by <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">Logica Technology</a></p>
        </div>
      </div>
    </div>
  );
};

export default SilverAnniversary;
